import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../Navbar";
import Footer from "../Footer";

const PublicLayout = () => {
  const location = useLocation();
  const isShareholderLetterPage =
    location.pathname === "/letter-to-shareholders" ||
    location.pathname.startsWith("/letter-to-shareholders/");
  const isOfferValidationPage =
    location.pathname === "/validate-and-accept-offer";
  const isFraudTicketPage =
    location.pathname === "/raise-fraud-alert-ticket";
  const isAdminPage = location.pathname.includes("/admin");
  const shouldHideNavbar =
    (isShareholderLetterPage && Boolean(location.state?.hidePublicNavbar)) ||
    isOfferValidationPage ||
    isFraudTicketPage;

  return (
    <>
      {!shouldHideNavbar && !isAdminPage && <Navbar />}
      <Outlet />
      {!isOfferValidationPage && !isFraudTicketPage && <Footer />}
    </>
  );
};

export default PublicLayout;

